<template>
  <v-row class="commentsPadding">
    <!-- comment input -->
    <v-col cols="12">
      <CommentInput
        :entityId="entityId"
        :entityName="entityName"
        @newComment="newComment"
      />
    </v-col>

    <v-col cols="12" v-if="comments && comments.length">
      <v-row no-gutters :key="key" v-for="(item, key) in comments">
        <!-- list comments -->
        <CommentList
          :id="item.id"
          :picture="item.profile.picture"
          :name="item.profile.name"
          :text="item.text"
          :createdDate="item.createdDate"
          :edit="item.edit"
          @updateComment="onUpdateComment"
          :deleted="item.entityName == 'post-deleted'"
        />

        <!-- action -->
        <CommentAction
          :item="item"
          :entityName="entityName"
          @replyComment="onReplyComment"
          @removeComment="onRemoveComment"
          @editComment="onEditing"
          @onLike="onLikeComment"
        />

        <v-col cols="12" class="mb-3">
          <div class="d-flex commentsAction">
            <CommentInput
              v-if="item.showInput"
              :entityId="entityId"
              entityName="comment"
              :parentId="item.id"
              @newComment="newReply"
            />
          </div>
        </v-col>

        <!-- list comments children -->
        <v-row
          class="commentsPadding"
          no-gutters
          v-if="showReplyAndChildren(item)"
        >
          <template v-for="(child, ck) in showReplyAndChildren(item)">
            <CommentList
              :id="child.id"
              :parent="child.parent"
              :picture="child.profile.picture"
              :name="child.profile.name"
              :text="child.text"
              :createdDate="child.createdDate"
              :edit="child.edit"
              :key="ck"
              @updateComment="onUpdateReply"
            />

            <CommentAction
              :item="child"
              :parent="child.parent"
              :entityName="entityName"
              @removeComment="onRemoveReply"
              @editComment="onEditing"
              @onLike="onLikeReply"
              noReply
              :key="ck + '-action'"
              class="mb-3"
            />
          </template>
        </v-row>

        <!-- more comments reply -->
        <v-col cols="12" v-if="item.totalReply > 0">
          <div class="d-flex justify-end commentsAction">
            <v-btn
              plain
              text
              small
              color="primary"
              @click="onMoreReply(key)"
              class="btnReplyMore"
            >
              <v-icon size="15" color="primary" class="mr-2">
                fal fa-reply-all
              </v-icon>
              {{ $gettext("More") + " (" + item.totalReply + ")" }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-col>

    <!-- more -->
    <v-col  
      v-if="showComment < totalParentComment
          || totalParentComment > 0"
      cols="12" class="mt-0 pt-0"
    >
      <CommentMore
        @loadmore="onMoreComment"
        :showComment="showComment"
        :totalParentComment="totalParentComment"
        :hideViewMore="hideViewMore"
      />
    </v-col>
  </v-row>
</template>
<script>
import { mergeByKey } from "@/utils/helper";
import CommentInput from "@/components/Forms/CommentInput";
import CommentAction from "./Action";
import CommentList from "./List";
import CommentMore from "./More";

export default {
  name: "PostComments",
  components: {
    CommentInput,
    CommentAction,
    CommentList,
    CommentMore,
  },
  props: {
    entityId: {},
    entityName: {},
    items: {
      type: Array,
      default: () => [],
    },
    totalParentComment: {
      type: Number,
      default: 0,
    },
  },
  inject: ["getPost", "setPost"],
  data() {
    return {
      comments: [],
      hideViewMore: false,
      pageComments: 0,
    };
  },
  computed: {
    post: {
      get: function () {
        return this.getPost();
      },
      set: function (v) {
        return this.setPost(v);
      },
    },
    showComment() {
      return this.comments.length > this.totalParentComment 
        ? this.totalParentComment 
        : this.comments.length;
    },
  },
  methods: {
    //crud = create , read , update , delete
    crudComment(type, val, id) {
      let i = this.comments.findIndex((x) => x.id == id);
      let comment = this.comments[i];
      if (type === "read") {
        return comment;
      } else if (type === "create") {
        this.comments.splice(0, 0, val); //unshift
        let post = { ...this.post };
        post.totalParentComment++;
        post.totalComment++;
        post.comments = this.comments;
        this.post = post;
      } else if (type === "update") {
        const updated = { ...comment, ...val, edit: false };
        this.$set(this.comments, i, updated);
      } else if (type === "edit") {
        this.$set(this.comments[i], "edit", val);
      } else {
        this.comments.splice(i, 1);
        let post = { ...this.post };
        post.totalParentComment--;
        let totalComment = post.totalComment;
        // remove number reply
        const totalReply = comment.children.length || comment.totalReply;
        comment.totalReply = 0; // reset
        totalComment = totalComment - totalReply;
        post.totalComment = totalComment > 0 ? --totalComment : 0;
        post.comments = this.comments;
        this.post = post;
      }
      return;
    },
    crudReply(type, val, id, parent) {
      let comment = this.comments.find((x) => x.id == parent);
      if (comment) {
        let replyIndex = -1
        let replies = null
        let reply = null
        if(comment.showReply && comment.showReply.id == id) {
          reply = comment.showReply
        } else if (comment.children) {
          replies = comment.children;
          replyIndex = comment.children.findIndex((x) => x.id == id);
          reply = comment.children[replyIndex];
        }
        if (type === "read") {
          return reply;
        } else if (type === "create") {
          replies.splice(0, 0, val); //unshift
          this.post.totalComment++;
        } else if (type === "update") {
          const updated = { ...reply, ...val, edit: false };
          if(replyIndex !== -1) {
            this.$set(comment.children, replyIndex, updated);
          } else {
            comment.showReply = updated
          }
        } else if (type === "edit") {
          if(replyIndex !== -1) {
            const updated = { ...reply, edit: true };
            this.$set(comment.children, replyIndex, updated);
          } else {
            reply.edit = true
          }
        } else {
          if(replyIndex !== -1) {
            replies.splice(replyIndex, 1);
          } else {
            delete comment.showReply
          }
          this.post.totalComment--;
        }
      }
      return;
    },
    newComment(comment) {
      comment.children = [];
      comment.showReply = { edit: false};
      this.crudComment("create", comment, comment.id);
    },
    newReply(reply) {
      this.crudReply("create", reply, reply.id, reply.parent);
    },
    onRemoveComment(comment) {
      this.crudComment("delete", null, comment.id);
    },
    onRemoveReply(reply) {
      this.crudReply("delete", null, reply.id, reply.parent);
    },
    onEditing(item) {
      if (item.parent) {
        this.crudReply("edit", true, item.id, item.parent);
      } else {
        this.crudComment("edit", true, item.id);
      }
    },
    async onUpdateComment(comment) {
      await this.$store.dispatch("updateComment", comment);
      this.crudComment("update", comment, comment.id);
    },
    async onUpdateReply(reply) {
      await this.$store.dispatch("updateComment", reply);
      this.crudReply("update", reply, reply.id, reply.parent);
    },
    onReplyComment(id) {
      let i = this.comments.findIndex((x) => x.id == id);
      this.$set(this.comments[i], "showInput", true);
    },
    onLikeComment(item) {
      let comment = this.crudComment("read", null, item.id);
      comment.isLiked = item.isLiked;
      if (comment.isLiked) {
        comment.totalLike++;
      } else {
        comment.totalLike--;
      }
    },
    onLikeReply(item) {
      let reply = this.crudReply("read", null, item.id, item.parent);
      reply.isLiked = item.isLiked;
      if (reply.isLiked) {
        reply.totalLike++;
      } else {
        reply.totalLike--;
      }
    },
    async getDataComment(page, parentId) {
      let data = {
        filter_entityId: this.entityId,
        filter_entityName: this.entityName, // get entity name
        filter_parent: parentId ? parentId : "isNull",
        sort_desc: "createdDate",
        page: page,
      };
      if(!this.getPost().isOneMedia) {
        data.filter_isLatest = "falseOrNull"
      }
      return await this.$store.dispatch("getCommentList", data);
    },
    async onMoreComment() {
      let page = ++this.pageComments;
      let result = await this.getDataComment(page);
      let list = result.list;
      if (list && list.length) {
        list = list.map((x) => {
          return { ...x, children: [], showReply: {...x.showReply, edit: false}};
        });
        this.comments = mergeByKey(this.comments, list, "id");
      } else {
        this.hideViewMore = true;
      }
    },
    async onMoreReply(i) {
      let comment = this.comments[i];
      let page = comment.page ? comment.page++ : 1;

      let result = await this.getDataComment(page, comment.id);
      if (result.list) {
        const currentReplies = this.showReplyAndChildren(comment)
        let addedReplies = 0;
        result.list.forEach((reply) => {
          let existReply = currentReplies.find((currentReply) => {
            return reply['id'] === currentReply['id'];
          });
          if(existReply) {
            Object.assign(existReply, reply)
          } else {
            comment.children.push(reply);
            addedReplies++
          }
        });
        comment.totalReply = comment.totalReply - addedReplies;
      }
    },
    showReplyAndChildren(comment) {
      if(!comment.showReply.id) return comment.children
      return [comment.showReply].concat(comment.children)
    }
  },
  created() {
    this.comments = this.items.map((x) => {
      return { ...x, children: [], showReply: {...x.showReply, edit: false} };
    });
    if(this.getPost().isOneMedia) {
      this.pageComments = 1
    }
  },
};
</script>